import { connect } from 'react-redux';
import { setClockSpeed } from '../Actions';
import SpeedControls from '../components/speedControl/SpeedControl';
function isSceneComplete(state) {
    return state.clock.time >= state.clock.stopTime;
}
const mapStateToProps = state => ({
    playing: state.clock.playing,
    speed: state.clock.speed,
    finished: isSceneComplete(state),
    isMobile: state.layout.isMobile,
});
const mapDispatchToProps = dispatch => ({
    setClockSpeed: newSpeed => {
        dispatch(setClockSpeed(parseInt(newSpeed, 10)));
        analytics.event({
            category: 'Navigation',
            action: `Change Speed to ${newSpeed}`,
        });
    },
    onPlayClick: isFinished => {
        if (isFinished) {
            dispatch({ type: 'TIME_RESET' });
            analytics.event({
                category: 'Navigation',
                action: 'Repeat Play',
            });
            return;
        }
        dispatch({ type: 'TOGGLE_PLAYING' });
        analytics.event({
            category: 'Navigation',
            action: 'Play/Pause',
        });
    },
});
const PlayerSpeedControls = connect(mapStateToProps, mapDispatchToProps)(SpeedControls);
export default PlayerSpeedControls;
